import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Login from '../components/Auth/Login';
import { ciosv2Authorize } from '../actions/api/apis';

class V2LoginContainer extends Component {
  constructor(props) {
    super(props);
    const { isLogin, dispatch, provider } = props;
    if (!isLogin) {
      dispatch(ciosv2Authorize(provider));
    }
  }

  render() {
    return <Login />;
  }
}

V2LoginContainer.propTypes = {
  isLogin: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  provider: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  isLogin: state.main.isLogin,
});
export default connect(mapStateToProps)(V2LoginContainer);
